import _ from 'underscore';
import BootstrapData from 'models/BootstrapData';
import MainBaseView from 'views/MainBaseView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { instanaTrackPage } from '@bizzabo/instana-api';
import Global from 'models/Global';

const CookiePreferencesPageView = MainBaseView.extend({
    events: {
        'click .settings-button': 'onSettingsButtonClick'
    },
    initialize: function(options) {
        options = options || {};
        FeatureToggleUtils.mergeFeatureToggleWithConfig();
        this.bootstrapData = options.bootstrapData;
        MainBaseView.prototype.initialize.apply(this, arguments);
        Global.set('page', 'cookie-preferences');
        instanaTrackPage('Cookie Preferences');
    },
    onSettingsButtonClick: function() {
        if (window.OneTrust) window.OneTrust.ToggleInfoDisplay();
    }
});

const event = BootstrapData('bootstrap-data-event');
const config = BootstrapData('bootstrap-data-config');
const isJoinedObject = BootstrapData('bootstrap-data-isJoinedObject');
const siteConf = BootstrapData('bootstrap-data-siteConf');
const settings = BootstrapData('bootstrap-data-settings');
const isCookieConsentEnabled = BootstrapData('bootstrap-data-isCookieConsentEnabled');

export default new CookiePreferencesPageView({
    el: $(document.body),
    bootstrapData: {
        event: event,
        eventID: event.id,
        settings: settings,
        config: config,
        siteConf: siteConf,
        isJoined: isJoinedObject.isJoined,
        isCookieConsentEnabled
    }
});

